import { components } from '@atlaskit/select';
import VisuallyHidden from '@atlaskit/visually-hidden';
import React from 'react';
export const CustomControl = props => {
  return /*#__PURE__*/React.createElement(VisuallyHidden, null, /*#__PURE__*/React.createElement(components.Control, props));
};